import React, { useState } from "react";
import { uploadToR2 } from "../../utils/r2Uploader";

function GameUploader() {
  const [file, setFile] = useState(null);
  const [status, setStatus] = useState("");

  const handleFileChange = (e) => setFile(e.target.files[0]);

  const handleUpload = async () => {
    if (!file) return;

    try {
      setStatus("Getting upload URL...");

      const res = await fetch(`/api/get-upload-url?filename=${file.name}`);
      const { url } = await res.json();

      setStatus("Uploading...");
      await uploadToR2(file, url);
      setStatus("✅ Upload complete!");
    } catch (err) {
      setStatus("❌ Upload failed");
      console.error(err);
    }
  };

  return (
    <div>
      <h2>Upload Game</h2>
      <input type="file" onChange={handleFileChange} />
      <button onClick={handleUpload}>Upload</button>
      <p>{status}</p>
    </div>
  );
}

export default GameUploader;
